import { render, staticRenderFns } from "./DuplicatesColumnInfos.vue?vue&type=template&id=2a29fb66"
import script from "./DuplicatesColumnInfos.vue?vue&type=script&lang=js"
export * from "./DuplicatesColumnInfos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports